import React from 'react';
import styled from 'styled-components';

import { bokehTheme } from '@vimeo/bokeh-theme';

import { ThumbnailImage, UserLinkWrapper, UserName } from './Styles';
import { AlbumThemes, ClipUser } from '../../types';
import { USER_KEY } from '../../utils/constants';
import { idFromUri } from '../../utils/helpers';

interface Props {
  user: ClipUser;
  isStock?: boolean;
  isFree?: boolean;
  isOffsite?: boolean;
  isImpersonatingViewerOrContrib: boolean;
  theme: AlbumThemes;
}

const UserLink = ({
  isFree,
  isImpersonatingViewerOrContrib,
  isStock,
  user,
  isOffsite = false,
  theme,
}: Props) => {
  const thumbnails: string[] = user.pictures.sizes.map((thumb) => `${thumb.link} ${thumb.width}w`);
  const userId = idFromUri(user?.uri, USER_KEY);
  const isDarkTheme = theme === 'dark';
  const userRedirect = isStock
    ? isFree
      ? `/stock/collection/5855140` // Redirects to stock essentials
      : `/stock/search?page=1&filter_user=/user/${userId}&via=stock-creator-albums`
    : user.link;

  if (isOffsite || isImpersonatingViewerOrContrib) {
    return (
      <StyledSpan isDarkTheme={isDarkTheme}>
        <ThumbnailImage src={user.pictures.sizes[0].link} srcSet={thumbnails.join(', ')} alt="" />
        <UserName>{user.name}</UserName>
      </StyledSpan>
    );
  }

  return (
    <UserLinkWrapper href={userRedirect} isDarkTheme={isDarkTheme} format="basic" variant="minimal">
      <ThumbnailImage src={user.pictures.sizes[0].link} srcSet={thumbnails.join(', ')} alt="" />
      <UserName>{user.name}</UserName>
    </UserLinkWrapper>
  );
};

const StyledSpan = styled.span<{ isDarkTheme: boolean }>`
  color: ${(props) => (props.isDarkTheme ? 'white' : bokehTheme.colors.gray['800'])};
`;

export default UserLink;
